import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "src/services/commonLanguageHeader";
import { ServicesUrlEndpoints } from "src/services/servicesEndpointConstant";

export type TireMeasureSortDirection = "ASC" | "DESC";

export interface TireMeasureListParams {
  page?: number;
  size?: number;
  sort?: TireMeasureSortDirection;
  sortBy?: string;
}

export interface TireMeasureRecord {
  id: string | number;
  name?: string;
  description?: string;
  active?: boolean | number | string;
  [key: string]: unknown;
}

export interface TireMeasurePayload {
  active: boolean;
  description?: string;
  name: string;
}

export interface TireMeasureStatusPayload {
  id: string | number;
  active: boolean;
}

export interface TireMeasurePaginatedResponse {
  resources?: TireMeasureRecord[];
  tireMeasures?: TireMeasureRecord[];
  data?: TireMeasureRecord[];
  items?: TireMeasureRecord[];
  content?: TireMeasureRecord[];
  totalItems?: number;
  totalElements?: number;
  total?: number;
}

const replaceId = (url: string, id: string | number) => url.replace("{id}", String(id));

export const getTireMeasuresList = (params: TireMeasureListParams = {}, language?: string) =>
  ApiService.get<{ response: TireMeasurePaginatedResponse }>(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MEASURE.LISTING,
    {
      params,
      ...getLanguageHeaders(language),
    }
  );

export const getTireMeasureById = (id: string | number, language?: string) =>
  ApiService.get<{ response: TireMeasureRecord }>(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MEASURE.GET, id),
    getLanguageHeaders(language)
  );

export const createTireMeasure = (payload: TireMeasurePayload, language?: string) =>
  ApiService.post(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MEASURE.ADD,
    payload,
    getLanguageHeaders(language)
  );

export const updateTireMeasure = (
  id: string | number,
  payload: TireMeasurePayload & { id: string | number },
  language?: string
) =>
  ApiService.patch(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MEASURE.UPDATE, id),
    payload,
    getLanguageHeaders(language)
  );

export const updateTireMeasureStatus = (
  id: string | number,
  payload: TireMeasureStatusPayload,
  language?: string
) =>
  ApiService.patch(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MEASURE.UPDATE, id),
    payload,
    getLanguageHeaders(language)
  );

export const deleteTireMeasure = (id: string | number, language?: string) =>
  ApiService.delete(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MEASURE.DELETE, id),
    getLanguageHeaders(language)
  );
